import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const customerFamiliarityWays = async () =>
  axios.get(Routes.CUSTOMER_FAMILIARITY_WAYS);

export const useCustomerFamiliarityWays = () =>
  useQuery({
    queryKey: [Keys.CUSTOMER_FAMILIARITY_WAYS_QRY],
    queryFn: customerFamiliarityWays,
  });
